import {
  CollectiveProposalType,
  useCollectiveProposalQuery,
  useProposalChangedSubscription
} from 'graphql/generated'
import { useCollectiveContext } from 'context/CollectiveContext'
import { useOnLinkedAccountChanged } from 'hooks/collectives/useOnLinkedAccountChanged'
import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { useCallback, useMemo } from 'react'
import { CollectiveProposalSurvey } from './CollectiveProposalSurveyType'
import { CollectiveProposalCommandType } from './CollectiveProposalCommandsType'

function CollectiveProposal({ proposalId }: { proposalId: string }) {
  const { collective, demoMode } = useCollectiveContext()

  const { data: { collectiveProposal: proposalMain } = {}, refetch } =
    useCollectiveProposalQuery({
      variables: {
        proposalId
      },
      skip: demoMode
    })

  useProposalChangedSubscription({
    variables: {
      proposalId
    },
    skip: demoMode,
    onData: () => refetch()
  })

  useOnLinkedAccountChanged(
    useCallback(() => {
      if (!demoMode) {
        refetch()
      }
    }, [demoMode, refetch])
  )

  const { viewingProposal } = useCollectiveDemoContext()

  const proposal = useMemo(
    () => proposalMain || viewingProposal,
    [viewingProposal, proposalMain]
  )

  if (!proposal) {
    return null
  }

  if (proposal.type === CollectiveProposalType.SURVEY) {
    if (!proposal.survey) {
      return null
    }
    return (
      <CollectiveProposalSurvey proposal={proposal} collective={collective} />
    )
  }

  return (
    <CollectiveProposalCommandType
      proposal={proposal}
      collective={collective}
      demoMode={demoMode}
    />
  )
}

export default CollectiveProposal
